<template>
    <div id="product-details-page" class="page product-details">
        <div class="container-xl">
            <div class="row product-details__content">
                <div class="col-12 col-md-6 product-details__img-wrap">  
                    <img :alt="currentProduct.name" :title="currentProduct.name" class="img-fluid" v-if="currentProduct.image || currentProduct.information_image" 
                    sizes="(max-width: 767px) 299px, 616px" 
                    :src="bigImg.src"
                    :srcset="bigImg.srcset" />                    
                    <!-- no-image -->
                    <img v-else src='@/assets/images/noimage/product-no-image.svg' :alt="currentProduct.name" :title="currentProduct.name" class="img-fluid" />
                    <!-- pack size -->
                    <div class="prod-pack-title" v-if="currentProduct.information_image && bigImg.name">
                        <span>{{ bigImg.name }}</span>
                    </div>
                </div>
                <div class="col-12 col-md-6 product-details__desc-wrap ">
                    <h1>{{ currentProduct.name }}</h1>
                    <div class="product-details__short-desc" v-if="currentProduct.short_description" v-html="currentProduct.short_description">
                        {{ currentProduct.short_description }}
                    </div>
                    <div class="product-details__desc details-page-desc" v-if="currentProduct.description" v-html="currentProduct.description">
                        {{ currentProduct.description }}
                    </div>
                    <div class="download-btn-wrap" v-if="downloads">
                        <a v-for="(document, docindex) in downloads" :key="docindex"  :href="src_url + '/' + document.document_id.path + '/' + document.document_id.file_name" class="btn btn--green-border" target="_blank">
                            {{ document.name }}
                        </a>
                    </div>                   
                    <div class="product-details__pack" v-if="currentProduct.information_image">
                        <div class="title" v-if="currentProduct.information_image.length >= 2">{{ lang('tovabbi_kiszerelesek')}}</div>
                        <ul >
                            <li v-for="pack in currentProduct.information_image" :key="pack.id" @click="changeBigImg(pack)">
                                <div v-if="bigImg.id != pack.id">
                                    <img :src="src_url + '/' + pack.image.cache.w286h440" :alt="pack.name" :title="pack.name" class="img-fluid"  />
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="product-details__related-recipes-block" v-if="relatedRecipes.length > 0">
            <div class="container-xl">
                <h3>{{lang('kapcsolodo_receptek')}}</h3>
                <div class="carousel-outer-wrap">
                    <div class="carousel-wrap">
                        <carousel v-if="relatedRecipes.length > 0"  :items="4" :margin="30" :autoWidth="true" :dots="false"  :loop="false" :responsive="{ 
                                    0:{
                                        items:1,
                                        autoWidth: true,
                                        margin: 0,
                                        mouseDrag: true,                                 
                                        nav: false},      
                                    576:{items:1, mouseDrag:true, nav:false, margin: 0},
                                    768:{items:2, mouseDrag:true, margin: 20},
                                    992:{items:3, mouseDrag:true, margin: 20},
                                    1200:{items:3, mouseDrag:false, margin: 30}                            
                        }">                                    
                            
                        <RecipeItem   v-for="recipe in relatedRecipes" :key="recipe.id"
                            :name="recipe.name"
                            :id="recipe.id"                                  
                            :recipe_slug="recipe.slug" 
                            :srcset="itemSrcset(recipe)" 
                            :src="itemSrc(recipe, 'w640h493')" 
                            :difficulty="recipe.difficulty"
                            :dish="recipe.dish"
                            :making_time="recipe.making_time" 
                        />  
                                                
                        </carousel> 
                </div>  
            </div>   
            <div class="carousel-block-btn-wrap">
                <router-link :to="{name: 'RecipesCategoryListAll_'+ currentLangName()}" class="btn btn--primary"><span>{{ lang("osszes_recept_megtekintese")}}</span></router-link>
            </div>      
            </div>
        </div>
        <div class="product-details__related-products-block" v-if="relatedProducts.length > 0">
            <div class="container-xl">
                <h3>{{ lang('hasonlo_termekek')}}</h3>
                <div class="carousel-outer-wrap">
                    <div class="carousel-wrap">            
                        <carousel v-if="relatedProducts.length > 0"  :items="4" :margin="30" :autoWidth="true" :dots="false"  :loop="false" :responsive="{ 
                                        0:{
                                            items:1,
                                            autoWidth: true,
                                            margin: 20,
                                            mouseDrag: true,                                 
                                            nav: false},      
                                        576:{items:2, mouseDrag:true, nav:false, margin: 20},
                                        768:{items:3, mouseDrag:true, margin: 20},                            
                                        992:{items:3, mouseDrag:false},
                                        1200:{items:4, mouseDrag:false}                            
                            }">                                    
                                
                                <ProductItem v-for="fProduct in relatedProducts" 
                                    :key="fProduct.id" 
                                    :name="fProduct.name"                         
                                    :product_slug="fProduct.slug" 
                                    :srcset="itemSrcset(fProduct)" :src="itemSrc(fProduct, 'w286h440')" 
                                    :id="fProduct.id"
                                />                        
                        </carousel>            
                    </div>  
                </div>                                   
            </div>
        </div>
    </div>
</template>

<script>
import carousel from 'vue-owl-carousel'
import RecipeItem from '@/components/pagesComponents/recipes/RecipeItem.vue'
import ProductItem from '@/components/pagesComponents/products/ProductItem.vue'
import axios from 'axios'

export default {
    data(){
        return{
            currentProduct: {},
            currentProductId: null,
            src_url: process.env.VUE_APP_BIFROST_API_URL_NO_PROJECTNAME,
            bigImg: {
                src: null,
                srcset: null,
                name: null,
                id: null
            },
            relatedRecipes: [],
            relatedProducts: [],
            metaImg: {
                src: null                
            }
        }
    },
    computed:{  
        downloads(){
            var ret = [];
            if (!this.currentProduct.download)
                return [];
            for (var i = 0; i<  this.currentProduct.download.length;i++){
                if (this.currentProduct.download[i].document_id)
                ret.push(this.currentProduct.download[i])
            }
            return ret;
        },
        currentProductSlug(){
            return this.$route.params.product_slug;
        },        
        langObject: function(){
            return this.$store.getters.getLang;                 
        }       
    },
    components:{
        carousel,
        RecipeItem,
        ProductItem
    },
    watch:{
        currentProductSlug: function(){
            this.relatedRecipes = [],
            this.relatedProducts = [] 
            this.getActualProduct();
        }                 
    },
    methods:{
        getActualProduct(){                                                     

            axios.get(process.env.VUE_APP_BIFROST_API_URL + '/information/'+ this.currentProductSlug + '?relations=1?relations=1&relations_params[information][where][0][0]=where&relations_params[information][where][0][1]=status&relations_params[information][where][0][2]=1&relations_params[information][order_by][0][0]=sort_order&relations_params[information][order_by][0][1]=asc&relations_params[information_image][order_by][0][0]=sort_order&relations_params[information_image][order_by][0][1]=asc&relations_params[download][where][0][0]=where&relations_params[download][where][0][1]=status&relations_params[download][where][0][2]=1&relations_params[download][order_by][0][0]=sort_order&relations_params[download][order_by][0][1]=asc'  ,{
                params:{
                    "language_id": this.$store.getters.getSelectedLang.id                         
                }
            }).then(response => {  
                // console.log('termek', response.data)              
                if (response.data.status == true){ 
                                    
                    if ( parseInt(response.data.information[0].status) === 1 ){
                        this.currentProduct = response.data.information[0]
                        this.currentProductId = response.data.information[0].id
                        this.getBigImgData()
                        this.setCurrentMetaTags()

                        if (response.data.information[0].information){
                            this.getRelatedData()
                        } else {
                            this.relatedProducts = []
                            this.relatedRecipes = []
                        }   
                    } else {
                        this.$router.push({name: '404-page'})
                    }
                    
                } else {                    
                    this.$router.push({name: '404-page'})
                }
                                             
            })
            .catch((err) => {
                console.log(err)                
            });             
            
        },
        getBigImgData(){
            if (this.currentProduct.information_image){
                this.bigImg.src = this.src_url + '/' + this.currentProduct.information_image[0].image.cache.w616h948
                this.bigImg.srcset = this.currentProduct.information_image[0].image.srcset,
                this.bigImg.name = this.currentProduct.information_image[0].name
                this.bigImg.id = this.currentProduct.information_image[0].id  
                
                this.metaImg = this.src_url + '/' + this.currentProduct.information_image[0].image.cache.w616h948
            } else if ( this.currentProduct.image && !this.currentProduct.information_image){
                this.bigImg.src = this.src_url + '/' + this.currentProduct.image.cache.w616h948
                this.bigImg.srcset = this.currentProduct.image.srcset,
                this.bigImg.name = null
                this.bigImg.id = null

                this.metaImg = this.src_url + '/' + this.currentProduct.image.cache.w616h948
            } else {
                this.bigImg.src = null,
                this.bigImg.srcset = null,
                this.bigImg.name = null
                this.bigImg.id = null
            }                                    
        },
        changeBigImg(item){
            this.bigImg.src = this.src_url + '/' + item.image.cache.w616h948
            this.bigImg.srcset = item.image.srcset
            this.bigImg.name = item.name
            this.bigImg.id = item.id
        },
        getRelatedData(){
            let _this = this;

            this.currentProduct.information.forEach(element => {
                if (element.type == 'product'){
                    _this.relatedProducts.push(element)
                } else if ( element.type == 'recipe'){
                    _this.relatedRecipes.push(element)
                }
            });
        },
        setCurrentMetaTags(){
            let _this = this            

            this.setMetaTags({
                title: _this.currentProduct.meta_title, 
                desc: _this.currentProduct.meta_description, 
                keywords: _this.currentProduct.meta_keywords, 
                ogType: 'products', 
                ogTitle: _this.currentProduct.meta_title,
                ogImage: this.metaImg, 
                ogImageWidth: null, 
                ogImageHeight: null, 
                ogDesc: _this.currentProduct.meta_description
            })
        }
    },
    created(){
        this.getActualProduct();
    }
}
</script>